export default __webpack_public_path__ + "static/media/ipX6.8122fd71.svg";